window.UnistarWishlist = (function () {
  const STORAGE_KEY = 'unistar_wishlist';

  function getAll() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveAll(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      console.error('Wishlist save failed', e);
    }
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
  }

  function has(id) {
    return getAll().some((item) => String(item.id) === String(id));
  }

  function add(product) {
    const items = getAll();
    if (items.some((item) => String(item.id) === String(product.id))) return items;
    items.unshift(product);
    saveAll(items);
    return items;
  }

  function remove(id) {
    const items = getAll().filter((item) => String(item.id) !== String(id));
    saveAll(items);
    return items;
  }

  function toggle(product) {
    if (has(product.id)) {
      remove(product.id);
      return false;
    } else {
      add(product);
      return true;
    }
  }

  function count() {
    return getAll().length;
  }

  return { getAll, saveAll, has, add, remove, toggle, count };
})();

function initWishlistCount() {
  document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
    el.textContent = window.UnistarWishlist.count();
  });
}

document.addEventListener('wishlist:updated', initWishlistCount);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlistCount);
} else {
  initWishlistCount();
}

document.addEventListener('shopify:section:load', initWishlistCount);